var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAudioPlay = function SvgAudioPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.34 291v442.03c0 33.71 37.12 54.19 65.71 35.84l347.31-221.01c26.45-16.64 26.45-55.04 0-72.11L407.04 255.16c-28.59-18.35-65.71 2.13-65.71 35.84Z"
  })));
};
export default SvgAudioPlay;